import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Art } from './Art';
import { VanShape } from './KeiVan';
/**
 * A small import shop with a striped awning and an indigo noren in the doorway, the kei van
 * parked out front. 260 × 150.
 */ export function ShopFront({ title, className }) {
    const stripes = Array.from({
        length: 8
    }, (_, i)=>/*#__PURE__*/ _jsx("path", {
            className: i % 2 ? 'fc' : 'fb',
            d: `M${44 + i * 22} 44h22l-3 16h-22Z`
        }, i));
    return /*#__PURE__*/ _jsxs(Art, {
        viewBox: "0 0 260 150",
        title: title,
        className: className,
        children: [
            /*#__PURE__*/ _jsx("path", {
                className: "fh",
                d: "M-4 134h268v16H-4Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                className: "fp",
                d: "M50 20h172v114H50Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                className: "fa",
                d: "M44 12h184v10H44Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                className: "fc thin",
                d: "M100 24h72v14h-72Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                className: "thin",
                d: "M110 31h52",
                opacity: ".6"
            }),
            stripes,
            /*#__PURE__*/ _jsx("path", {
                className: "thin",
                d: "M41 60h176"
            }),
            /*#__PURE__*/ _jsx("path", {
                className: "fa2",
                d: "M64 72h58v40H64Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                className: "sc thin",
                d: "m72 104 12-24M88 104l12-24",
                opacity: ".55"
            }),
            /*#__PURE__*/ _jsx("path", {
                className: "fp",
                d: "M150 70h46v64h-46Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                className: "fa",
                d: "M152 72h42v26h-42Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                className: "sc thin",
                d: "M166 72v26M180 72v26",
                opacity: ".7"
            }),
            /*#__PURE__*/ _jsx("circle", {
                className: "fo n",
                cx: "190",
                cy: "112",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("g", {
                transform: "translate(6 70) scale(.9)",
                children: /*#__PURE__*/ _jsx(VanShape, {})
            })
        ]
    });
}
